import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface GetRefreshSaleHistoryStatusParameter {
  kreamProductId: number;
}

export interface GetRefreshSaleHistoryStatusRequest {}

export interface GetRefreshSaleHistoryStatusResponse {
  status: string;
}

export const getRefreshSaleHistoryStatusKey: YWRKey<GetRefreshSaleHistoryStatusParameter> =
  {
    url: ({ kreamProductId }) =>
      `/kream/products/${kreamProductId}/refresh-sale-history/status`,
    method: "get",
  };

export default function useGetRefreshSaleHistoryStatus() {
  const fetcher = useFetcher<
    GetRefreshSaleHistoryStatusRequest,
    GetRefreshSaleHistoryStatusResponse
  >();
  return useYWR(getRefreshSaleHistoryStatusKey, fetcher);
}
